<template>
  <div>
    <div class="legend">
      <div style="margin-bottom: 4px; justify-content: center;" class="row" v-for="(lable, i) in labels" :key="lable">
        <div class="col-7" style="display: flex; align-items: center;">
          <div :style="{'margin-right':'5px',display: 'inline-block', height: '1em', width: '1em', backgroundColor: legendColors[i]}"></div> {{lable}}
        </div>
      </div>
    </div>
    <canvas :id="title||'myChart'" :width="width || '400'" :height="height||'400'" style="font-size: 2em;"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js";
import { hexToRGB } from "./utils";

export default {
  name: "doughnut-chart",
  props: [
    "labels",
    "datasets",
    "data",
    "color",
    "backgroundColor",
    "extraOptions",
    "title",
    "primaryColor",
    "height",
    "width",
  ],
  data() {
    return {
      chartData: {},
      defaultOptions: {
        legend: {
          display: false,
          position: "top",
          labels: {
            boxWidth: 15,
          },
          align: "start",
        },
        tooltips: {
          enabled: false,
          bodySpacing: 4,
          mode: "nearest",
          intersect: 0,
          position: "nearest",
          xPadding: 10,
          yPadding: 10,
          caretPadding: 10,
        },
        responsive: true,
        layout: {
          padding: { left: 40, "inset-inline-end": 40, top: 15, bottom: 15 },
        },
      },
      chart: {},
      legendColors: [],
    };
  },

  mounted() {
    this.renderDoughnutChart();
  },

  methods: {
    renderDoughnutChart() {
      Chart.defaults.global.defaultFontSize = 15;
      const ctx = document
        .getElementById(this.title || "myChart")
        .getContext("2d");

      let bgColors = [
        hexToRGB(this.primaryColor, 0.6) || "rgba(255, 159, 64, 0.6)",
        "rgba(255, 99, 132, 0.6)",
        "rgba(54, 162, 235, 0.6)",
        "rgba(255, 206, 86, 0.6)",
        "rgba(75, 192, 192, 0.6)",
        "rgba(153, 102, 255, 0.6)",
      ];
      this.legendColors = bgColors;
      let bgColors2 = [
        hexToRGB(this.primaryColor, 0.1) || "rgba(255, 159, 64, 0)",
        "rgba(255, 99, 132, 0)",
        "rgba(54, 162, 235, 0)",
        "rgba(255, 206, 86, 0)",
        "rgba(75, 192, 192, 0)",
        "rgba(153, 102, 255, 0)",
      ];
      let borderColor = [
        hexToRGB(this.primaryColor, 0.6) || "rgba(255, 159, 64, 1)",
        "rgba(255, 99, 132, 1)",
        "rgba(54, 162, 235, 1)",
        "rgba(255, 206, 86, 1)",
        "rgba(75, 192, 192, 1)",
        "rgba(153, 102, 255, 1)",
      ];
      let gradientArray = [];
      for (const i in bgColors) {
        const color = bgColors[i];
        const color2 = bgColors2[i];

        const gradientFill = ctx.createLinearGradient(0, 170, 0, 50);
        gradientFill.addColorStop(0, color);
        gradientFill.addColorStop(1, color2);
        gradientArray.push(gradientFill);
      }
      let data = this.data;
      let options = this.defaultOptions;
      const myChart = new Chart(ctx, {
        type: "doughnut",
        data: {
          labels: this.labels,
          datasets: [
            {
              data: data,
              backgroundColor: gradientArray,
              borderColor: borderColor,
              borderWidth: 1,
            },
          ],
        },
        options: options,
      });
      this.chart = myChart;
    },

    updateChart() {
      this.chart.update();
    },
  },

  watch: {
    data() {
      this.renderDoughnutChart();
    },
  },
};
</script>

<style>
</style>

